module.exports = __webpack_public_path__ + "static/media/freedomlySocialShare.525006bb.png";